define('RecipesAndEvents.Ingredients.View', [
    'Backbone.CollectionView',
    'RecipesAndEvents.Ingredient.View',
    'RecipesAndEvents.Collection',
    'RecipesAndEvents.KitCart.Confirmation.View',
    'ProductDetails.AddToProductList.View',
    'SC.Configuration',
    'LiveOrder.Model',
    'ProductList.Control.View',
    'item_relations_ingredients.tpl',
    'item_relations_ingredients_row.tpl',
    'item_relations_ingredients_cell.tpl',
    'jQuery',
    'Backbone',
    'underscore',
    'Utils'
], function RecipesAndEventsIngredientsView(
    BackboneCollectionView,
    RecipesAndEventsIngredientView,
    RecipesAndEventsCollection,
    RecipesAndEventsKitCartConfirmationView,
    ProductDetailsAddToProductListView,
    Configuration,
    LiveOrderModel,
    ProductListControlItemView,
    itemRelationsIngredientsTpl,
    itemRelationsIngredientsRowTpl,
    itemRelationsIngredientsCellTpl,
    jQuery,
    Backbone,
    _
) {
    'use strict';

    return BackboneCollectionView.extend({
        ingredients: [],
        events: {
            'click [data-type="add-kit-to-cart"]': 'addKitToCart',
            'click [data-action="product-list-recipe"]': 'pListItemHandler'
        },
        childViews: {
            AddToProductList: function AddToProductList() {
                return new ProductDetailsAddToProductListView({
                    model: this.model,
                    application: this.application
                });
            }
        },
        initialize: function initialize(options) {
            var itemId;
            var self;
            this.application = options.application;
            this.model = options.model;
            itemId = this.model && this.model.get('item') && this.model.get('item').id;
            self = this;
            this.collection = new RecipesAndEventsCollection();

            BackboneCollectionView.prototype.initialize.call(this, {
                collection: self.collection,
                viewsPerRow: Infinity,
                cellTemplate: itemRelationsIngredientsCellTpl,
                rowTemplate: itemRelationsIngredientsRowTpl,
                childView: RecipesAndEventsIngredientView,
                template: itemRelationsIngredientsTpl,
                childViewOptions: {
                    application: self.application
                }
            });

            self.collection.fetch({ data: { id: itemId } }).done(function onDone() {
                self.model.ingredients = self.collection.models;
                self.ingredients = self.collection.models;
                self.render();
                _.defer(function deferCarrousel() {
                    // We need to use jQuery because with the regular this.$ doesn't work properly
                    jQuery('[data-type="carousel-items"]').bxSlider(_.extend({}, Configuration.bxSliderDefaults, {
                        infiniteLoop: false,
                        touchEnabled: false
                    }));
                });
            });
        },
        pListItemHandler: function pListItemHandler(e) {
            var checkbox = jQuery(e.target);
            ProductListControlItemView.prototype.addRemoveProducts(checkbox, this.ingredients);
        },
        getLineByItemId: function getLineByItemId(lines, itemId) {
            return _.find(lines, function fnFind(line) {
                return line.item && line.item.internalid && line.item.internalid === itemId;
            });
        },
        addKitToCart: function addKitToCart() {
            var application = this.options.application;
            var self = this;
            var addKitView;
            var errorMessage =
                _('Sorry, there is a problem with this Item and can not be purchased at this time. Please check back later.').translate();
            var cart = application.getComponent('Cart');
            _.each(this.ingredients, function eachIngredients(model) {
                if (cart) {
                    cart.getLines().done(function onGetLinesDone(lines) {
                        var line = self.getLineByItemId(lines, model.id);
                        var quantity;
                        if (line) {
                            quantity = line.quantity + 1;
                            cart.updateLine({
                                line: {
                                    internalid: line.internalid,
                                    quantity: quantity
                                }
                            }).fail(function onUpdateLineFail() {
                                self.showError(errorMessage);
                            });
                        } else {
                            cart.addLine({
                                line: {
                                    quantity: 1,
                                    item: {
                                        internalid: model.id
                                    }
                                }
                            }).fail(function onAddLineFail() {
                                self.showError(errorMessage);
                            });
                        }
                    });
                }
            });
            addKitView = new RecipesAndEventsKitCartConfirmationView({
                layout: this,
                application: this.application,
                model: this.model,
                ingredients: this.ingredients
            });
            addKitView.showInModal();
        }
    });
});
